import React from 'react';
import { useStateSelector } from '../../providers/stateManager';
import { selectEditCommentId } from '../../utils/selectors';
import { Provider } from './providers';
import EditHeader from './EditHeader';
import ImagesBlock from './ImagesBlock';
import Form from './Form';
import FilesBlock from './FilesBlock';
import styles from './index.module.scss';

const ModalFooter = () => {
  const editCommentId = useStateSelector(selectEditCommentId);
  const hasEditComment = Boolean(editCommentId);

  return (
    <Provider hasEditComment={hasEditComment}>
      <div className={styles.root}>
        {hasEditComment && <EditHeader />}

        <ImagesBlock commentId={editCommentId} />

        <Form />

        <FilesBlock commentId={editCommentId} />
      </div>
    </Provider>
  );
};

export default ModalFooter;
